import axios from "axios";
import { serialize } from "../../core/utils/_util";
export const ORDER_HISTORY = `/api/v1/customer/order-history`;
export const ADDITIONAL_POINTS_CUSTOMER = `/api/v1/customer/additional-points`;

// order history data
export function orderHistoryData(
  restaurantSearch,
  tierFilter,
  pointEarnedFilter,
  cashbackFilter,
  page
) {
  const object = {
    restaurantName: restaurantSearch,
    orderTier: tierFilter,
    pointEarned_lower: pointEarnedFilter?.lv,
    pointEarned_upper: pointEarnedFilter?.hv,
    cashbackStatus: cashbackFilter,
    page: page,
  };
  return axios.get(`${ORDER_HISTORY}?${serialize(object)}`, {
    validateStatus(status) {
      return true;
    },
  });
}

// get additional points
export function getAdditionalPoints() {
  return axios.get(ADDITIONAL_POINTS_CUSTOMER, {
    validateStatus(status) {
      return true;
    },
  });
}

// Get receipt submissions
export function getReceiptSubmissions({
  id,
  restaurantStoreId,
  status,
  startDate,
  endDate,
  page = 1,
  pageSize = 10,
  sortBy = "createdAt",
  sortOrder = "desc",
}) {
  const params = {
    id,
    restaurantStoreId,
    status,
    startDate,
    endDate,
    page,
    pageSize,
    sortBy,
    sortOrder,
  };

  return axios.get(`/api/v1/customer/receipts?${serialize(params)}`, {
    validateStatus(status) {
      return true;
    },
  });
}

// Delete receipt submission in pending
export function deleteReceiptSubmision(id) {
  return axios.delete(`/api/v1/customer/receipts/${id}`, {
    validateStatus(status) {
      return true;
    },
  });
}
